module.exports = __webpack_public_path__ + "img/full7-min.99bdf9f9.png";